<app-header></app-header>
<!-- Hero Section -->
<main class="container mx-auto px-4 pb-6 lg:px-6 lg:py-8">
        <!-- Hero Section -->
        <section class="mt-4 mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-primary to-wattpad-secondary rounded-xl p-6 lg:p-8 text-white">
                <div class="flex flex-col lg:flex-row gap-6 items-center">
                    <div class="lg:w-1/3 flex justify-center">
                        <div class="bg-white/20 p-6 rounded-full w-48 h-48 flex items-center justify-center">
                            <i class="fas fa-pen-nib text-6xl"></i>
                        </div>
                    </div>
                    <div class="lg:w-2/3 text-center lg:text-left">
                        <h1 class="text-2xl lg:text-4xl font-bold mb-2">✍️ Funtel StoryFest 2025</h1>
                        <p class="text-lg lg:text-2xl mb-4">Write. Win. Shine.</p>
                        
                        <p class="text-sm lg:text-base mb-6">
                            क्या आपके पास ऐसी कहानी है जो लाखों दिल जीत सकती है?<br>
                            अब मौका है अपनी कलम की ताकत दिखाने का और जीतने का शानदार इनाम!
                        </p>
                        
                        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <button (click)="createnew()" id="writeBtn" class="bg-white text-wattpad-primary px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition-colors text-lg">
                                Write Now
                            </button>
                            <a href="javascript:void(0)"
   (click)="scrollToSection('details')"
   class="bg-white/20 text-white px-8 py-3 rounded-full font-medium hover:bg-white/30 transition-colors text-lg">
  Learn More
</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Countdown Section -->
        <section class="mb-8 lg:mb-12">
  <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
    <h2 class="text-xl lg:text-2xl font-bold mb-6 text-center text-wattpad-primary">
      Submission Deadline
    </h2>

    <div class="flex justify-center gap-4 flex-wrap">
      <div class="countdown-item bg-gray-100 dark:bg-gray-700 p-4 rounded-lg text-center">
        <div class="text-3xl font-bold">{{ days }}</div>
        <div class="text-sm">Days</div>
      </div>
      <div class="countdown-item bg-gray-100 dark:bg-gray-700 p-4 rounded-lg text-center">
        <div class="text-3xl font-bold">{{ hours }}</div>
        <div class="text-sm">Hours</div>
      </div>
      <div class="countdown-item bg-gray-100 dark:bg-gray-700 p-4 rounded-lg text-center">
        <div class="text-3xl font-bold">{{ minutes }}</div>
        <div class="text-sm">Minutes</div>
      </div>
      <div class="countdown-item bg-gray-100 dark:bg-gray-700 p-4 rounded-lg text-center">
        <div class="text-3xl font-bold">{{ seconds }}</div>
        <div class="text-sm">Seconds</div>
      </div>
    </div>
  </div>
</section>


        <!-- Prizes Section -->
        <section class="mb-8 lg:mb-12" id="details">
            <h2 class="text-xl lg:text-2xl font-bold mb-4 lg:mb-6">🏆 इनाम / Prizes</h2>
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="competition-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm text-center">
                    <div class="bg-wattpad-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span class="text-wattpad-primary text-3xl font-bold">1</span>
                    </div>
                    <h3 class="font-bold text-lg mb-2">First Prize</h3>
                    <p class="text-2xl font-bold text-wattpad-primary mb-2">₹5,000</p>
                    <p class="text-sm text-wattpad-light">Plus digital certificate and social media feature</p>
                </div>
                
                <div class="competition-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm text-center">
                    <div class="bg-wattpad-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span class="text-wattpad-primary text-3xl font-bold">2</span>
                    </div>
                    <h3 class="font-bold text-lg mb-2">Second Prize</h3>
                    <p class="text-2xl font-bold text-wattpad-primary mb-2">₹2,500</p>
                    <p class="text-sm text-wattpad-light">Plus digital certificate and social media feature</p>
                </div>
                
                <div class="competition-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm text-center">
                    <div class="bg-wattpad-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span class="text-wattpad-primary text-3xl font-bold">3</span>
                    </div>
                    <h3 class="font-bold text-lg mb-2">Third Prize</h3>
                    <p class="text-2xl font-bold text-wattpad-primary mb-2">₹1,000</p>
                    <p class="text-sm text-wattpad-light">Plus digital certificate and social media feature</p>
                </div>
            </div>
            
            <div class="mt-6 bg-wattpad-secondary/10 rounded-xl p-6 text-center">
                <p class="text-wattpad-secondary font-medium">
                    सभी प्रतिभागियों को डिजिटल सर्टिफिकेट मिलेगा और टॉप कहानियों को Funtel Stories के सोशल मीडिया पेज पर फीचर किया जाएगा।
                </p>
            </div>
        </section>

        <!-- Requirements Section -->
        <section class="mb-8 lg:mb-12" id="details">
            <h2 class="text-xl lg:text-2xl font-bold mb-4 lg:mb-6">📜 भाग लेने की शर्तें / Participation Requirements</h2>
            
            <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
                <ul class="space-y-3">
                    <li class="flex items-start">
                        <i class="fas fa-check-circle text-wattpad-primary mt-1 mr-3"></i>
                        <span>कहानी एपिसोडिक फॉर्मेट में होनी चाहिए। (Story must be in episodic format)</span>
                    </li>
                    <li class="flex items-start">
                        <i class="fas fa-check-circle text-wattpad-primary mt-1 mr-3"></i>
                        <span>कम से कम 10 एपिसोड अनिवार्य (हर एपिसोड 1,000 – 2,000 शब्द)। (Minimum 10 episodes required, each 1,000-2,000 words)</span>
                    </li>
                    <li class="flex items-start">
                        <i class="fas fa-check-circle text-wattpad-primary mt-1 mr-3"></i>
                        <span>कोई भी जॉनर चलेगा — हॉरर, थ्रिलर, रोमांस, ड्रामा, मिस्ट्री, फैंटेसी आदि। (Any genre accepted)</span>
                    </li>
                    <li class="flex items-start">
                        <i class="fas fa-check-circle text-wattpad-primary mt-1 mr-3"></i>
                        <span>कहानी पूरी तरह मौलिक (original) होनी चाहिए। (Story must be completely original)</span>
                    </li>
                    <li class="flex items-start">
                        <i class="fas fa-check-circle text-wattpad-primary mt-1 mr-3"></i>
                        <span>भाषा: हिंदी या अंग्रेज़ी (मिश्रित भाषा स्वीकार नहीं)। (Language: Hindi or English only, no mixed language)</span>
                    </li>
                    <li class="flex items-start">
                        <i class="fas fa-check-circle text-wattpad-primary mt-1 mr-3"></i>
                        <span>सबमिशन की आखिरी तारीख: 31 दिसंबर 2025 (Submission deadline: December 31, 2025)</span>
                    </li>
                </ul>
            </div>
        </section>

        <!-- Terms & Conditions Section -->
        <section class="mb-8 lg:mb-12">
            <h2 class="text-xl lg:text-2xl font-bold mb-4 lg:mb-6">📌 Terms & Conditions</h2>
            
            <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
                <div class="space-y-4">
                    <div>
                        <h3 class="font-bold mb-1">Eligibility:</h3>
                        <p class="text-wattpad-light">18 वर्ष या उससे अधिक उम्र के सभी लेखक भाग ले सकते हैं। (All writers 18 years or older can participate)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Originality:</h3>
                        <p class="text-wattpad-light">नकल या कॉपीराइट उल्लंघन पर डिस्क्वालिफिकेशन होगा। (Plagiarism or copyright violation will lead to disqualification)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Format:</h3>
                        <p class="text-wattpad-light">केवल Funtel Stories प्लेटफ़ॉर्म पर प्रकाशित सीरीज़ ही स्वीकार की जाएगी। (Only series published on Funtel Stories platform will be accepted)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Minimum Requirement:</h3>
                        <p class="text-wattpad-light">अधूरी कहानियों पर विचार नहीं किया जाएगा। (Incomplete stories will not be considered)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Review Process:</h3>
                        <p class="text-wattpad-light">विजेताओं का चयन Funtel रिव्यू टीम करेगी, निर्णय अंतिम होगा। (Winners selected by Funtel review team, decision is final)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Prizes:</h3>
                        <p class="text-wattpad-light">इनाम राशि विजेता घोषित होने के 15 कार्य दिवसों में ट्रांसफर की जाएगी। (Prize money will be transferred within 15 working days of winner announcement)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Rights:</h3>
                        <p class="text-wattpad-light">विजेता कहानियों के प्रकाशन और प्रचार का पूरा अधिकार Funtel Studio के पास रहेगा। (Funtel Studio retains full rights for publication and promotion of winning stories)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">Disqualification:</h3>
                        <p class="text-wattpad-light">नियम उल्लंघन, आपत्तिजनक सामग्री, या गलत जानकारी पर तुरंत अयोग्यता घोषित होगा। (Immediate disqualification for rule violation, offensive content, or false information)</p>
                    </div>
                    <div>
                        <h3 class="font-bold mb-1">No Entry Fee:</h3>
                        <p class="text-wattpad-light">भाग लेने के लिए कोई शुल्क नहीं। (No fee to participate)</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- CTA Section -->
        <section class="mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-accent to-wattpad-primary rounded-xl p-8 text-white text-center">
                <h2 class="text-2xl lg:text-3xl font-bold mb-4">📢 तो देर किस बात की? / What are you waiting for?</h2>
                <p class="text-lg mb-6">
                    Funtel Stories पर अपनी सीरीज़ शुरू करें, कमाल का कंटेंट लिखें, और जीतें हज़ारों रुपये के इनाम!<br>
                    (Start your series on Funtel Stories, write amazing content, and win thousands in prizes!)
                </p>
                <button (click)="createnew()" id="finalWriteBtn" class="bg-white text-wattpad-primary px-8 py-4 rounded-full font-bold hover:bg-gray-100 transition-colors text-xl">
                    Write Now
                </button>
            </div>
        </section>

      
    </main>